module.exports = __webpack_public_path__ + "static/media/ionic.ede229b9.png";